import { combineReducers } from 'redux';
import common from './slices/common.slice';

export const rootReducer = combineReducers({
  common,
});
